/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

export default {
  intro: {
    title: 'Bonjour {{name}}',
    introduction:
      'Prêt(e) à commencer votre séance d’exercices? Concentrez-vous sur les contractions musculaires et tentez de les sentir, même si vous ne voyez rien bouger. Laissez le reste du visage au repos.',
    instruction: 'Faites les exercices lentement en suivant le rythme proposé.',
  },
  permission: {
    title: 'Permission',
    introduction:
      'Pour être en mesure de poursuivre votre séance, vous devez autoriser l’accès de cette page Web à votre caméra et à votre microphone.',
    instruction:
      'Pour avoir accès à votre séance, vous devrez d’abord l’autoriser en modifiant les paramètres de votre navigateur.',
  },
};
